import React, { useEffect, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import Swal from "sweetalert2";
import '../../../libs/css/bootstrap.min3.3.7.css';
import '../../../libs/css/sweetalert2.min.css';
import { API_ROUTES } from "../../../utils/constants";
import { useForm } from "react-hook-form";
import CPEndpointTable from "./CPEndpointTable";
import Nulls from "../Nulls";



export default function ViewCpEndpoint(props){
    const {objectToFormData, errorFunction, Helmet, capitalizeWords, isAuthExpired, allCPs} = props;

    const [cpOptions, setCpOptions] = useState([]);
    const [cpOptionsLoading, setCpOptionsLoading] = useState(false);
    const [selectedCP, setSelectedCP] = useState("");

    const [isLoading, setIsLoading] = useState(true);
    const [dataTotal, setDataTotal] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [columns, setColumns] = useState([]);
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const [isFade, setIsFade] = useState(false);


    useEffect(() => {document.title = "View CP Endpoint | Forthsoft"}, []);

    useEffect(() => {
        const loadScript = (src) => {
          return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
          });
        };
        Promise.all([
        //   loadScript('../assets/libs_/js/jquery.min.js'),
          loadScript('../assets/libs_/js/scripts2.js'),
        ])
          .then(() => {
            // Both scripts are loaded
          })
          .catch((error) => {
            console.error('Error loading scripts:', error);
          });
        return () => {
          // Remove the scripts here if necessary
        };
    }, []);


    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const { register: register1, setValue: setValue1, reset: reset1, handleSubmit: handleSubmit1, formState: {errors: errors1, isSubmitting: isSubmitting1, isValid: isValid1} } = useForm({mode: 'onChange'});

    useEffect(() => {document.title = `Update CP Endpoint | Forthsoft`}, []);



    const updateCpEndpoints = async (data) => {
        const datas = {
            cp_id:                  data.cp_name,
            service_id:             data.cp_id,
            subscription_endpoint:  data.sub_endpoint,
        }

        try {
            const response = await fetch(API_ROUTES.UPDATE_CP_ENDPOINT, {
                method: "POST",
                body: objectToFormData(datas),
                headers: {'token': userData?.responseDetails?.token},
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON); // check for expired login

            Swal.fire({
                title: 'Processing...',
                text: "Please wait a second for a response...",
                icon: 'success',
                showConfirmButton: false,
                confirmButtonColor: '#027937',
                cancelButtonColor: '#d33',
            });

            if(responseJSON.status.toString() === "200"){
                Swal.fire({
                    title: "Successful",
                    text: `A CP Endpoint has been updated`,
                    icon: "success",
                    timer: 4000
                });
                getData();
            }else{
                if(responseJSON.status.toString() === "500"){
                    Swal.fire({
                        title: "Error",
                        text: responseJSON.required_fields,
                        icon: "error",
                    });
                    return;
                }
                Swal.fire({
                    title: "Error",
                    text: responseJSON.message,
                    icon: "error",
                });
            }
        } catch (error) {
            if(error.response){
                errorFunction(error);
            }
        }
    }


    const handleCPClick = async (e) => {
        const value = e.target.value;
        setSelectedCP(value);
        setValue1("cp_name", value);

        const data = { 
            cp_id: value,
            per_page: 100,
        };

        setCpOptions([]);
        setCpOptionsLoading(true);

        try {
            const response = await fetch(API_ROUTES.VIEW_CP_SERVICES, {
                method: "POST",
                body: objectToFormData(data),
                headers: {'token': userData?.responseDetails?.token},
            });
            const responseJSON = await response.json();

            isAuthExpired(responseJSON); // check for expired login

            if(responseJSON.status.toString() === "200"){
                
                const uniqueServiceId = Array.from(
                    new Map(responseJSON.data.map(item => [item.serviceId, item])).values()
                );

                // console.log("uniqueServiceIdsss", uniqueServiceId);
                
                setCpOptions(uniqueServiceId);

                setCpOptionsLoading(false);
            }else{
                setCpOptions([]);
                setCpOptionsLoading(true);
                if(responseJSON.status.toString() === "500"){
                    Swal.fire({
                        title: "Error",
                        text: responseJSON.required_fields,
                        icon: "error",
                    });
                    return;
                }
                Swal.fire({
                    title: "Error",
                    text: responseJSON.message,
                    icon: "error",
                });
            }
        } catch (error) {
            if(error.response){
                errorFunction(error);
                setCpOptions([]);
                setCpOptionsLoading(true);
            }
        } 
    }


    const getData = async () => {
        setIsFade(true);
        try {
            const response = await fetch(API_ROUTES.VIEW_CP_ENDPOINT, {
                method: "POST",
                headers: {'token': userData?.responseDetails?.token},
            });

            const responseJSON = await response.json();
            isAuthExpired(responseJSON); // check for expired login

            // console.log("responseJSON ===>", responseJSON);

            if (responseJSON.status.toString() === "200") {
                const responseData = responseJSON.data;

                const uniqueData = responseData.filter(
                    (item, index, self) => index === self.findIndex(t => t.id === item.id)
                );

                const sortedData = uniqueData.sort((a, b) => b.id - a.id);
                
                const totalData = sortedData.length;
                setDataTotal(totalData);
                setDataList(sortedData);
                setIsLoading(false);
                setIsFade(false);
            }
        } catch (error) {
            console.log('Error getting data: ', error);
            setDataTotal({});
            setDataList([]);
            setIsLoading(false);
            setIsFade(false);
        }
    }


    useEffect(() => {
        getData();
    }, []);



    const columns1 = [
        {   
            name: 'CP Name',
            selector: row => row.cp_name ? capitalizeWords(row.cp_name) : <Nulls />,
            sortable: true,
        },
        {   
            name: 'Service Name',
            selector: row => row.service_name ? capitalizeWords(row.service_name) : <Nulls />,
            sortable: true,
        },
        {
            name: 'Service ID',
            selector: row => row.service_id ? row.service_id : <Nulls />,
            sortable: true,
        },
        {   
            name: 'Endpoint',
            selector: row => row.endpoint ? row.endpoint : <Nulls />,
        },
        // {   
        //     name: 'Created',
        //     selector: row => row.created_at ? moment(row.created_at).format('MMMM Do h:mma') : <Nulls />,
        // },
    ];


    useEffect(() => {
        setColumns(columns1);
    }, []);

    


    return (
        <>
            <Loaders />

            <div className="flapt-page-wrapper mainContent">
                <Menus />

                <div className="flapt-page-content">
                    <HeaderTop />

                    <div className="main-content introduction-farm mt-5">
                        <div className="content-wraper-area">
                            <div className="dashboard-area">
                                <div className="container-fluid mb-90 mt-20">
                                    <div className="row g-4 pl-15 pl-xs-0">
                                        <div className="col-lg-12 p-xs-0"> 
                                            <div className="card">
                                                <div className="card-header">
                                                    <h3>Update CP Endpoint</h3>
                                                </div>
                                                <div className="card-body formInputs">
                                                    <div className="horizontal-wizard-wrapper vertical-options">
                                                        <div className="row">
                                                            <div className="col-md-12 pl-xs-5 pr-xs-5">
                                                                <div className="tab-content pt-0 pl-10 pr-5 pl-xs-0 pr-xs-0 pb-10" id="vertical-wizard-tabContent_">
                                                                    <div className="tab-pane active" id="change-passwords" role="tabpanel" aria-labelledby="change-passwords-tab">
                                                                        <form className="row" onSubmit={handleSubmit1(updateCpEndpoints)}>
                                                                            <div className="card-body p-10 pb-10">
                                                                                <div className="row">
                                                                                    
                                                                                    <div className="col-sm-6 mb-15">
                                                                                        <label className="form-label" htmlFor="name">CP Name</label>

                                                                                        <select 
                                                                                            className='filter_text' 
                                                                                            onChange={handleCPClick} 
                                                                                            // {...register1("cp_name", { required: "CP Name is required" })} 
                                                                                            style={{ textTransform:'capitalize' }}
                                                                                        >
                                                                                            <option value="">-Select CP-</option>
                                                                                            {
                                                                                                allCPs.length !== 0 && allCPs.map(mycp => { 
                                                                                                    return <option key={mycp.id} value={mycp.id}>{mycp.name}</option>
                                                                                                })
                                                                                            }
                                                                                        </select>
                                                                                    </div>

                                                                                    <div className="col-sm-6 mb-15">
                                                                                        <label className="form-label" htmlFor="email">Service Name</label>
                                                                                        <select className='filter_text' {...register1("cp_id", { required: "Service is required" })} style={{ textTransform:'capitalize', opacity: cpOptions.length !== 0 || !cpOptionsLoading ? 1 : 0.4 }}>
                                                                                            <option value=""> {cpOptions.length !== 0 || !cpOptionsLoading ? `-Select Service- ${cpOptions.length > 0 ? '('+cpOptions.length+')' : ''}` : "Loading..."}</option>
                                                                                            {
                                                                                                cpOptions.length !== 0 ?
                                                                                                cpOptions.map((opt, index) => (
                                                                                                    <option key={`${opt.serviceId}_${index}`} value={opt.serviceId}>{opt.serviceName}</option>
                                                                                                ))
                                                                                                :
                                                                                                <option value="" disabled>None</option>
                                                                                            }
                                                                                        </select>
                                                                                    </div>

                                                                                    <div className="col-md-12 mb-10">
                                                                                        <label className="form-label" htmlFor="sub_endpoint">Subscription Endpoint</label>
                                                                                        {errors1.sub_endpoint && <label className="errors">{errors1.sub_endpoint?.message}</label>}

                                                                                        <input className="form-control" id="sub_endpoint" type="text" name="sub_endpoint" 
                                                                                        placeholder="Enter Endpoint" 
                                                                                        {...register1("sub_endpoint", {
                                                                                            required: 'Subscription endpoint is required',
                                                                                            pattern: {
                                                                                                value: /^(https?:\/\/)([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/,
                                                                                                message: "Enter a valid URL starting with http:// or https://",
                                                                                            },
                                                                                        })}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                    
                                                                                <div className="row mt-20">
                                                                                    <div className="offset-md-6 col-md-6 text-end pr-10">
                                                                                        <button className="btn btn-primary btn-primaryi" type="submit" disabled={isSubmitting1 || !isValid1} style={{ opacity: isSubmitting1 ? '0.5' : 1 }}>Update CP Endpoint</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-12 pl-xs-0 pr-xs-0">
                                                    <div className="card-header">
                                                        <h2>CP Endpoints</h2>
                                                    </div>
                                                    <CPEndpointTable dataList={dataList} dataTotal={dataTotal} isLoading={isLoading} columns={columns} countPerPage={countPerPage} setPage={setPage} isFade={isFade} />
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footers />
                    </div>
                </div>
            </div>
        </>
    );
}